<template>
	<div class="display-flex flex-wrap">
		<div class="flex-col-12 form-section">
			<InfoSection class="py-4 px-3 mt-4">
				<div class="text-center">
					<h5>If this feature is published, changes to the trigger setup take effect immediately.</h5>
				</div>
			</InfoSection>
			<ToolCommandInputField class="mt-5" v-model="command" />
			<ToolIconInputField class="pt-2" v-model="icon" />
		</div>
		<div class="flex-1 flex-center--end actions-section">
			<PrimaryButton class="mt-5" :disabled="!hasUnsavedChanges" @click="save" :loading="loading">Save</PrimaryButton>
		</div>
	</div>
</template>

<script>
import ToolCommandInputField from '@/components/CreationWizard/Steps/ChooseToolPlacement/ToolPlacementDataComponents/common/ToolCommandInputField.vue';
import ToolIconInputField from '@/components/CreationWizard/Steps/ChooseToolPlacement/ToolPlacementDataComponents/common/ToolIconInputField.vue';
import WorkflowToolService from '@/utils/workflow-tool-service';

export default {
	name: 'CommandBarToolPlacementEditor',
	props: { workflow: { type: Object }, loading: { type: Boolean } },
	components: { ToolCommandInputField, ToolIconInputField },
	computed: {
		hasUnsavedChanges() {
			return (
				this.command !== WorkflowToolService.getToolPreferences(this.workflow).command_bar_title ||
				this.icon.icon.name !== this.workflow.icon_name
			);
		},
	},
	methods: {
		confirmSaveBeforeLeaving() {
			return this.hasUnsavedChanges && window.confirm('You have unsaved changes! Do you want to save them first?');
		},
		save() {
			this.$emit('save-workflow', { icon_name: this.icon.icon.name, tool_preferences: { command_bar_title: this.command } });
		},
	},
	data() {
		return {
			command: WorkflowToolService.getToolPreferences(this.workflow).command_bar_title,
			icon: {
				icon: {
					name: this.workflow.icon_name,
					size: 12,
				},
			},
		};
	},
	beforeDestroy() {
		if (this.confirmSaveBeforeLeaving()) {
			this.save();
		}
	},
};
</script>

<style lang="scss" scoped>
.form-section {
	z-index: $z-index-2;
}
.actions-section {
	z-index: $z-index-1;
}
</style>
